<template>
  <v-app style="width: 100%" class="pa-3 pt-0">
    <div
      style="
        position: fixed;
        background-color: #fff;
        border-radius: 10px;
        padding: 10px;
        z-index: 10;
      "
    >
      <div class="d-flex">
        <v-btn
          v-shortkey="['f8']"
          color="primary"
          small
          class="me-2 mt-1 mb-1"
          outlined
          style="font-size: 10px"
          @shortkey="print"
          @click="print"
        >
          <v-icon color="pOrrange" style="font-size: 18px" class="me-2">
            mdi-printer-outline
          </v-icon>
          {{ $t("print") }} (f8)
        </v-btn>
        <v-btn
          color="primary"
          small
          class="me-2 mt-1 mb-1"
          outlined
          style="font-size: 10px"
          :loading="loading"
          @click="captureAndSharePDF('pdf')"
        >
          <v-icon color="pOrrange" style="font-size: 18px" class="me-2">
            mdi-file-pdf-box
          </v-icon>
          {{ $t("getFilepdf") }}
        </v-btn>
        <v-btn
          color="primary"
          small
          class="me-2 mt-1 mb-1"
          outlined
          style="font-size: 10px"
          :loading="loading"
          @click="captureAndSharePDF('share')"
        >
          <v-icon color="pOrrange" style="font-size: 18px" class="me-2">
            mdi-share-variant-outline
          </v-icon>
          {{ $t("share") }}
        </v-btn>
      </div>
    </div>
    <!-- <v-row class="mx-3 mb-4 mt-14">
      <v-expansion-panels v-model="panel" class="mt-2 px-0">
        <v-expansion-panel>
          <v-expansion-panel-header>
            {{ $t("printAndPageSetting") }}
            ✏️
          </v-expansion-panel-header>
          <v-expansion-panel-content>
            <v-row>
              <v-col md="3">
                <p class="mb-0 mt-1">{{ $t("orientationPage&size") }} :</p>
              </v-col>
              <v-col md="3">
                <v-radio-group v-model="size" row hide-details class="me-9 mt-0">
                  <v-radio :label="$t('A5')" value="a5" />
                  <v-radio :label="$t('A4')" value="a4" />
                </v-radio-group>
              </v-col>
              <v-col md="3">
                <v-radio-group v-model="layout" row hide-details class="mt-0">
                  <v-radio :label="$t('portrait')" value="portrait" />
                  <v-radio :label="$t('landscape')" value="landscape" />
                </v-radio-group>
              </v-col>
            </v-row>
            <v-row v-if="layout === 'portrait'" class="setting-layout">
              <v-col cols="12" md="6">
                {{ $t("designing") }} : <templateSelector v-model="template" />
              </v-col>
              <v-col cols="12" md="6">
                {{ $t("coloring") }} : <colorSelector v-model="color" />
              </v-col>
            </v-row>
          </v-expansion-panel-content>
        </v-expansion-panel>
      </v-expansion-panels>
    </v-row> -->
    <!-- <div
      id="print"
      style="direction: rtl; background-color: white; color: #000000"
      class="px-3 mx-auto main-layout"
      :style="{
        zoom: isMobile && !pdfGenerate ? (layout === 'portrait' ? '0.45' : '0.33') : null,
        'main-layout': isMobile && !pdfGenerate ? '0.45' : '1',
      }"
    >
      <div
        v-for="(page, i) in printPage"
        :key="i"
        :class="[layoutClass]"
        class="pagemargins"
        :style="{ 'page-break-before': i > 0 ? 'always' : null }"
      >
        <div class="header-print" style="border: 0px !important">
          <div v-if="template && color" class="page-background-print">
            <printBackground
              :template="template + (layout === 'landscape' ? '-land' : '')"
              :color="color"
            />
          </div>
        </div>
        <div
          class="body-print"
          style="z-index: 2; position: absolute; padding: 0cm 0.4cm"
          :style="{
            top: template && template !== 'undefined' && color ? '2.1cm' : '0.5cm',
          }"
        >
          <div style="width: 100%; right: 0">
            <div
              class="top-header-print"
              style="display: flex; width: 100%; padding: 5px"
            >
              <div style="width: 25%; padding-right: 0.5cm">
                <img
                  class="ms-2"
                  :src="base64Logo ? 'data:image/png;base64,' + base64Logo : ''"
                  width="65"
                  style="max-height: 65px"
                />
              </div>
              <div style="width: 50%; text-align: center">
                <h3>{{ $store.state.abrName }}</h3>
                <v-card-text class="pa-0 ma-0 mt-1 text-body-2">
                  {{ $t("name_and_lastName") }}: {{ page.name }}</v-card-text
                >
                <div
                  style="
                    display: flex;
                    justify-content: center;
                    gap: 16px;
                    font-size: 12px;
                    margin-top: 4px;
                  "
                >
                  <div>{{ $t("personnelCode") }}: {{ page.personnelCode }}</div>

                  <div>{{ $t("national-code") }}: {{ page.nationalCode }}</div>
                </div>
                <h5>
                  {{ fromDate ? $t("fromDate") + " : " + fromDate : "" }}
                  {{ fromDate && toDate ? " - " : "" }}
                  {{ toDate ? $t("toDate") + " : " + toDate : "" }}
                </h5>
              </div>
              <div
                class="float-end"
                style="width: 25%; padding-right: 1cm; padding-top: 8px; font-size: 10px"
              >
                <div>{{ $t("reportDate") }} : {{ getToday() }}</div>
                <div>{{ $t("salary_slip") }} : {{ page.year }}/{{ page.month }}</div>
                <div>
                  {{ $t("currency") }} :
                  {{ currencyProp ? currencyProp.name : $store.state.currency.name }}
                </div>
              </div>
            </div>
          </div>
          <div v-show="!page.hideHeader" class="table-header-print">
            <div
              v-for="(head, h) in headerProp"
              :key="h"
              class="table-header-td-print"
              :style="{ width: head.width ? head.width + '%' : autoWidth + '%' }"
            >
              {{ head.text }}
            </div>
          </div>
          <div v-for="(item, m) in page.items" :key="m" v-html="item"></div>
        </div>
        <div
          class="footer-page-print"
          :style="{ bottom: template && color ? '25px' : '13px' }"
        >
          {{ $t("page") }} {{ page.page }} {{ $t("from") }} {{ printPage.length }}
        </div>
        <div
          class="footer-abriron-print"
          :style="{ bottom: template && color ? '25px' : '13px' }"
        >
          {{ $t("FinancialSolutionsAbriron") }}
        </div>
      </div>
    </div> -->
    <!-- SOURCE ROWS FOR PRINT ENGINE -->
    <!-- <div ref="refItems" style="display: none; width: 21cm"> -->
    <!-- <template v-for="(item, j) in items">
        <template
          v-if="
            item.__employeeBreak &&
            items[j + 1] &&
            !items[j + 1].__employeeBreak &&
            items[j + 1].month
          "
        >
          <div
            class="top-header-print print-row"
            style="display: flex; width: 100%; padding: 5px"
          >
            <div style="width: 25%; padding-right: 0.5cm">
              <img
                class="ms-2"
                :src="'data:image/png;base64,' + base64Logo"
                width="65"
                style="max-height: 65px"
              />
            </div>

            <div style="width: 50%; text-align: center">
              <h3>{{ $store.state.abrName }}</h3>

              <v-card-text class="pa-0 ma-0 mt-1 text-body-2">
                {{ $t("name_and_lastName") }}: {{ items[j + 1].name }}
              </v-card-text>

              <div
                style="
                  display: flex;
                  justify-content: center;
                  gap: 16px;
                  font-size: 12px;
                  margin-top: 4px;
                "
              >
                <div>{{ $t("personnelCode") }}: {{ items[j + 1].personnelCode }}</div>

                <div>{{ $t("national-code") }}: {{ items[j + 1].nationalCode }}</div>
              </div>

              <h5>
                {{ fromDate ? $t("fromDate") + " : " + fromDate : "" }}
                {{ fromDate && toDate ? " - " : "" }}
                {{ toDate ? $t("toDate") + " : " + toDate : "" }}
              </h5>
            </div>

            <div
              class="float-end"
              style="width: 25%; padding-right: 1cm; padding-top: 8px; font-size: 10px"
            >
              <div>{{ $t("reportDate") }} : {{ getToday() }}</div>

              <div>
                {{ $t("salary_slip") }} : {{ items[j + 1].year }}/{{ items[j + 1].month }}
              </div>

              <div>
                {{ $t("currency") }} :
                {{ currencyProp ? currencyProp.name : $store.state.currency.name }}
              </div>
            </div>
          </div>

          <div
            class="print-row"
            style="display: flex; font-weight: bold; background: #e3e3e3"
          >
            <div
              v-for="(head, b) in headerProp"
              :key="'h' + b"
              class="table-header-td-print"
              :style="{ width: head.width ? head.width + '%' : autoWidth + '%' }"
            >
              {{ $t(head.text) }}
            </div>
          </div>
        </template> -->
    <!-- <div
          v-if="!item.__employeeBreak && item.month"
          :key="'row' + j"
          style="display: flex"
          class="print-row"
        >
          <div
            v-for="(head, b) in headerProp"
            :key="b"
            class="table-body-td-print"
            :style="{ width: head.width ? head.width + '%' : autoWidth + '%' }"
          >
            <div v-if="head.type === 'number'">
              {{
                $numberFormat(
                  item[head.value],
                  item.currency && item.currency.decimal ? item.currency.decimal : ""
                )
              }}
            </div>

            <div v-else-if="head.type === 'translate'">
              {{ $t(item[head.value]) }}
            </div>

            <div
              v-if="multiLineCells && typeof item[head.value] === 'string'"
              v-html="item[head.value].replace(/\n/g, '<br>')"
            />

            <div v-else>
              {{ item[head.value] }}
            </div>
          </div>
        </div> -->
    <!-- <template
          v-if="
            !item.__employeeBreak &&
            ((items[j + 1] && items[j + 1].__employeeBreak) ||
              (isSinglePrint && j === items.length - 1))
          "
        >
          <div
            class="print-row sum-row"
            style="display: flex; font-weight: bold; background: #f3f3f3"
          >
            <div
              v-for="(head, i) in headerProp"
              :key="'sum' + i"
              class="table-body-td-print"
              :style="{ width: head.width ? head.width + '%' : autoWidth + '%' }"
            >
              <template v-if="i === 3"> {{ $t("sumPayment") }} </template>
              <template v-else-if="i === 4">
                {{ $numberFormat(item.benefitAmountSum || 0) }}
              </template>
              <template v-else-if="i === 5">
                {{ $t("sum") }} {{ $t("deductions") }}
              </template>
              <template v-else-if="i === 6">
                {{ $numberFormat(item.deductionAmountSum || 0) }}
              </template>
            </div>
          </div>
        </template> -->
    <!-- <div
          v-if="
            !item.__employeeBreak &&
            ((items[j + 1] && items[j + 1].__employeeBreak) ||
              (isSinglePrint && j === items.length - 1))
          "
          class="print-row sum-row"
          style="display: flex; font-weight: bold; background: #e8f5e9"
        >
          <div
            v-for="(head, i) in headerProp"
            :key="'payable' + i"
            class="table-body-td-print"
            :style="{ width: head.width ? head.width + '%' : autoWidth + '%' }"
          >
            <template v-if="i === headerProp.length - 2"> {{ $t("netPay") }} </template>
            <template v-else-if="i === headerProp.length - 1">
              {{ $numberFormat(calculateTotals(item).netPay) }}
            </template>
          </div>
        </div> -->
    <!-- </template> -->
    <!-- </div> -->

    <!-- <v-dialog
      v-model="customSizeDialog"
      :fullscreen="isMobile"
      :hide-overlay="isMobile"
      width="60%"
    >
      <v-card>
        <v-col class="d-flex pb-0">
          <v-btn icon color="grey darken-2" @click="customSizeDialog = false">
            <v-icon class="close-hover" large> mdi-close </v-icon>
          </v-btn>
          <p class="mx-auto font-weight-medium mt-2">
            {{ $t("print-size") }}
          </p>
        </v-col>
        <v-row class="ma-0">
          <v-col cols="12" sm="6" md="6">
            <v-text-field
              v-model="width"
              outlined
              dense
              type="number"
              :label="$t('width') + '(cm)'"
            />
          </v-col>
          <v-col cols="12" sm="6" md="6">
            <v-text-field
              v-model="height"
              outlined
              dense
              type="number"
              :label="$t('height') + '(cm)'"
            />
          </v-col>
        </v-row>
        <v-card-actions>
          <v-row class="ma-0">
            <v-col cols="6">
              <v-btn color="primary" @click="setCustomeSize">
                {{ $t("submit") }}
              </v-btn>
            </v-col>
            <v-col cols="6">
              <v-btn
                color="grey"
                outlined
                class="float-left"
                @click="customSizeDialog = false"
              >
                {{ $t("cancel") }}
              </v-btn>
            </v-col>
          </v-row>
        </v-card-actions>
      </v-card>
    </v-dialog> -->
    <v-snackbar
      v-model="snakbar"
      :color="snakbarColor ? snakbarColor : ''"
      top
      style="z-index: 1000000000000 !important"
    >
      {{ snakbarText }}

      <template v-slot:action="{ attrs }">
        <v-btn color="white" text v-bind="attrs" @click="snakbar = !snakbar">
          {{ $t("close") }}
        </v-btn>
      </template>
    </v-snackbar>
  </v-app>
</template>

<script>
import store from "../../../../../../../store";
import General from "../../../../../../../Mixins/general";
import templateSelector from "../../../../../components/general/Print/partial/printTemplateSelector.vue";
import colorSelector from "../../../../../components/general/Print/partial/printColorSelector.vue";
import printBackground from "../../../../../components/general/Print/partial/printBackground.vue";

export default {
  components: {
    templateSelector,
    colorSelector,
    printBackground,
  },

  mixins: [General],

  props: [
    "headerProp",
    "itemsProp",
    "title",
    "idProp",
    "dialog",
    "fromDate",
    "toDate",
    "productItemsInvoice",
    "dataProp",
    "reviewTotalsProp",
    "showSummaryTransferContentProp",
    "invoiceTotalsProp",
    "reviewLevelProp",
    "typeProp",
    "currencyProp",
    "turnoverProp",
    "multiLineCells",
  ],

  data() {
    return {
      printPage: [],
      items: [],
      timer: 0,
      loading: false,
      size: "a4",
      layout: "portrait",
      template: null,
      color: null,
      base64Logo: null,
      pdfGenerate: false,
    };
  },

  computed: {
    isSinglePrint() {
      if (!this.itemsProp) return false;
      const employees = this.groupItemsByEmployee(this.itemsProp);
      return employees.length === 1;
    },
    autoWidth() {
      const totalWidth = this.headerProp.reduce(
        (sum, head) => sum + (head.width ? parseFloat(head.width) : 0),
        0
      );
      const remainingWidth = 100 - totalWidth;
      const emptyColumns = this.headerProp.filter((head) => !head.width).length;

      return emptyColumns > 0 ? remainingWidth / emptyColumns : 0;
    },
    layoutClass() {
      if (this.layout === "portrait") {
        return {
          "main-page-print": true,
          "border-off": this.pdfGenerate,
        };
      }
      return {
        "main-page-landscape-print": true,
        "border-off": this.pdfGenerate,
      };
    },
    isMobile() {
      return this.$vuetify.breakpoint.name === "xs";
    },
  },

  watch: {
    dialog(val) {
      if (val) {
        this.prepareItems();
      }
    },
    itemsProp() {
      this.prepareItems();
    },
    layout() {
      this.renderPrinter();
    },
    size() {
      this.renderPrinter();
    },
    template() {
      this.renderPrinter();
    },
  },
  mounted() {
    if (this.itemsProp) {
      this.prepareItems();
    }

    this.getBase64Logo();
  },
  methods: {
    calculateTotals(item) {
      const benefit = Number(item.benefitAmountSum || 0);
      const deduction = Number(item.deductionAmountSum || 0);
      return {
        benefitTotal: benefit,
        deductionTotal: deduction,
        netPay: benefit - deduction,
      };
    },
    // GROUP ITEMS BY EMPLOYEE
    groupItemsByEmployee(items) {
      const map = {};
      items.forEach((item) => {
        const id =
          item.employeeId ||
          item.employee?.id ||
          item.personnelCode ||
          item.employee?.personnelCode;

        if (!map[id]) {
          map[id] = {
            name: item.employee?.name || item.name,
            personnelCode: item.employee?.personnelCode || item.personnelCode,
            nationalCode: item.employee?.nationalCode || item.nationalCode,
            items: [],
          };
        }

        map[id].items.push(item);
      });

      return Object.values(map);
    },

    // PREPARE ITEMS FOR PRINT ENGINE
    prepareItems() {
      if (!this.itemsProp) return;

      const employees = this.groupItemsByEmployee(this.itemsProp);

      const newItems = [];

      employees.forEach((emp, index) => {
        emp.items.forEach((item) => {
          newItems.push({
            ...item,
            name: emp.name,
            personnelCode: emp.personnelCode,
            nationalCode: emp.nationalCode,
          });
        });

        if (index !== employees.length - 1 && emp.items.length) {
          newItems.push({
            __employeeBreak: true,
          });
        }
      });

      while (newItems.length && newItems[newItems.length - 1].__employeeBreak) {
        newItems.pop();
      }

      this.items = newItems;

      this.renderPrinter();
    },

    // PRINT ENGINE
    renderPrinter() {
      clearTimeout(this.timer);

      this.timer = setTimeout(() => {
        const app = this;
        app.printPage = [];

        const container = app.$refs.refItems;
        container.style.display = "block";

        setTimeout(() => {
          const maxHeight = app.layout === "landscape" ? 720 : 950;
          const rows = container.querySelectorAll(".print-row");

          let pages = [];
          let currentPage = [];
          let currentHeight = 0;

          let currentEmployee = null;
          let pageEmployee = null;

          rows.forEach((row) => {
            const html = row.outerHTML;
            const height = row.offsetHeight;

            const index = app.items.findIndex(
              (it) =>
                !it.__employeeBreak &&
                html.includes(it.personnelCode || "") &&
                html.includes(it.name || "")
            );

            if (index !== -1) {
              currentEmployee = app.items[index];

              // ✅ اگر صفحه تازه شروع شده کاربر صفحه را ثبت کن
              if (!pageEmployee) {
                pageEmployee = currentEmployee;
              }
            }

            const isBreak = html.includes("__employeeBreak");

            if (isBreak) {
              if (currentPage.length) {
                pages.push({
                  rows: currentPage,
                  employee: pageEmployee,
                });
              }

              currentPage = [];
              currentHeight = 0;
              pageEmployee = null;
              return;
            }

            if (currentHeight + height > maxHeight) {
              pages.push({
                rows: currentPage,
                employee: pageEmployee,
              });

              currentPage = [];
              currentHeight = 0;

              // ✅ صفحه جدید از همین کاربر شروع می‌شود
              pageEmployee = currentEmployee;
            }

            currentPage.push(html);
            currentHeight += height;
          });

          if (currentPage.length) {
            pages.push({
              rows: currentPage,
              employee: pageEmployee || currentEmployee,
            });
          }
          pages = pages.filter((p) =>
            p.rows.some((r) => r.includes("table-body-td-print") || r.includes("sum-row"))
          );

          app.printPage = pages.map((p, i) => ({
            page: i + 1,
            items: p.rows,
            hideHeader: false,
            name: p.employee?.name || "",
            personnelCode: p.employee?.personnelCode || "",
            nationalCode: p.employee?.nationalCode || "",
            month: p.employee?.month || "",
            year: p.employee?.year || "",
          }));
        }, 200);

        setTimeout(() => {
          container.style.display = "none";
        }, 600);
      }, 400);
    },
    print() {
      const prtHtml = document.getElementById("print").innerHTML;

      const WinPrint = window.open("", "", "left=0,top=0,width=1100,height=900");

      WinPrint.document.write(`
        <html>
        <head>
        <style>
        @page {size:${this.size} ${this.layout};margin:5px}
        </style>
        </head>
        <body>${prtHtml}</body>
        </html>
      `);

      WinPrint.document.close();

      setTimeout(() => {
        WinPrint.print();
        WinPrint.close();
      }, 500);
    },

    getBase64Logo() {
      const logo = JSON.parse(localStorage.getItem("token"));

      if (!logo?.init?.logo) return;

      this.$axios
        .get(this.$endpoint + "getdetail?select=urlToBase64&url=" + logo.init.logo.link)
        .then((res) => {
          this.base64Logo = res.data;
        });
    },
  },
};
</script>

<style scoped>
.sum-row .table-body-td-print {
  font-weight: bold;
  background: #f6f6f6;
  border-top: 2px solid #000;
  padding-top: 6px;
  padding-right: 4px;
  padding-bottom: 6px;
}

.top-header-print {
  font-size: 10px;
  border-top-left-radius: 4px;
  border-top-right-radius: 4px;
  margin-top: 12px;
  border: 1px solid #292929;
  display: flex;
}

@media print {
  @page {
    margin: 0px;
    padding: 0;
  }
  .main-page-print {
    width: 21cm;
    height: 29.68cm;
    position: relative;
    border: 0px !important;
    padding: 10px;
    white-space: normal;
  }
  .main-page-landscape-print {
    border: 0px solid !important;
    padding: 10px;
    white-space: normal;
  }
  .table-header-td-print {
    -webkit-print-color-adjust: exact !important;
  }
  .body-print > .print-article:nth-child(even) > .table-body-td-print {
    -webkit-print-color-adjust: exact !important;
  }
}
.pagemargins {
  page-break-after: always;
  padding: 5.08mm 10mm 5.08mm 10mm;
  border: 0;
  direction: rtl;
}
.footer-page-print {
  position: absolute;
  bottom: 20px;
  border-radius: 4px;
  padding: 0px 7px;
  right: 0.5cm;
  background-color: #ffffff;
  font-size: 10px;
}
.footer-abriron-print {
  position: absolute;
  bottom: 20px;
  border-radius: 4px;
  padding: 0px 7px;
  left: 0.7cm;
  font-size: 9px;
  background-color: #ffffff;
  color: #1c1c1c;
}
.table-header-td-print {
  display: inline-block;
  width: 1cm;
  border: 0.5px solid #262626;
  height: 30px;
  font-size: 10px;
  border-left: none !important;
  padding: 5px;
  background-color: #e7e7e7;
}

.table-header-print {
  display: flex;
  width: 100%;
}
.border-off {
  border: 0px !important;
}
.main-page-landscape-print {
  width: 29.68cm;
  height: 20.8cm;
  position: relative;
  border: 0.5px solid;
  padding: 10px;
  white-space: normal;
}
.main-page-print {
  width: 21cm;
  height: 29.68cm;
  position: relative;
  border: 0.5px solid;
  padding: 10px;
  white-space: normal;
}
.body-print {
  direction: rtl;
  width: 100%;
  right: 0;
}
.body-print > .print-article:last-child > div:first-child {
  border-bottom-right-radius: 4px;
}
.body-print > .print-article:last-child > div:last-child {
  border-bottom-left-radius: 4px;
}
.share-button {
  width: 28px;
  height: 28px;
  min-width: 0px !important;
  min-height: 0px !important;
  padding: 0px 0px !important;
}
.page-background-print {
  position: absolute;
  width: 100%;
  top: 0;
  right: 0;
  padding: 10px;
}
.table-header-td-print:first-child {
  border-top-right-radius: 0px;
}
.table-header-td-print:last-child {
  border-top-left-radius: 0px;
  border-left: 0.5px solid #262626 !important;
}
.table-body-td-print {
  display: inline-block !important;
  font-size: 10px !important;
  word-wrap: break-word !important;
  white-space: normal;
  word-break: break-word !important;
  border-left: none !important;
  border-top: none !important;
  border: 0.5px solid #000000;
  padding: 5px !important;
}
.table-body-td-print:last-child {
  border-left: 0.5px solid #000000 !important;
}
.print-article {
  display: flex;
  width: 100%;
  margin: 0cm 0cm;
}
.body-print > .print-article:nth-child(even) > .table-body-td-print {
  background-color: #e7e7e7;
}
</style>
